<div class="route-content" [attr.aria-busy]="isRouteLoading()" [attr.inert]="isRouteLoading() ? '' : null">
    <router-outlet />
</div>

@if (isRouteLoading()) {
    <eaglei-loading-indicator class="route-loading-indicator" presentation="panel" [blocking]="true" message="Loading page…" />
}

<vulcan-notify />
